import { withInstall } from '@tw-element/utils'
import Tooltip from './src/tooltip.vue'

export const TwTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/tokens'
export default TwTooltip
